module.exports = __webpack_public_path__ + "img/DSCN0280.38fb2523.jpg";